import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../../services/seo.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  constructor(private seoService: SeoService) { }

  ngOnInit(): void {
    this.seoService.setSEOTags(
      'About Us',
      'Insightful IT Services is a leading provider of Cloud Services and Managed IT Solutions in India. Enterprise-grade infrastructure with 24/7 support and 99.9% uptime SLA.',
      'Insightful IT Services, Cloud Provider India, Managed IT Company, Enterprise IT Solutions, IT Services Provider India, Cloud Infrastructure India'
    );
  }

}
